import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Landing from "../components/Landing";

export default withRouter(connect()(Landing));
